<script>
    import DesktopButton2 from '../../reusableitems/DesktopButton2.svelte';
</script>
<section>
    <div class="maindiv">
        <div class="backimg">
            <img src="/images/Artist/backimg.png" alt="" width="100%" height="100%">
        </div>
        <div class="menimg">
            <img src="/images/Artist/men.png" alt="" width="100%" height="100%">
        </div>
        <div class="onediv">
            <p>5</p>
        </div>
        <div class="virtualhead">
            <p>Virtual Fashion &<br> Apparel Designers</p>
        </div>
        <div class="descriptiontext" >
            <p>For the first time ever, we’re giving fashion designers a front row seat into the world of gaming and metaverse. </p>
                <p style="padding: 1.85vh 0;">No longer will the characters be wearing skin tight bodysuits (unless if that’s the fashion), rather it’s the time to bring them equal to their human counterparts.</p>
                
               <p style="font-weight: 700;">Our simulation technology enables clothes and accessories to demonstrate near-to-real physics using state-of-the-art technology. The future is here and you’re invited to be part of it.</p>  
        </div>
        <div class="btn">
            <DesktopButton2 
                state = "Artists & Musicians"
                AnimationColor='#00FFFF' 
                text1='Join Visual Art Governance Council'
                text3='25'
                TextColorAfter='black'
                text2='(Character Seat)'/>
        </div>
    </div>
</section>
<style>
    .maindiv{
        width: 195.556vh ;
        height: 100vh;
        background-color: #59E7F1;
        position: relative;
        font-family: 'Orbitron';
    }
    .backimg{
        width: 98.333vh ;
        height: 68.333vh ;
        position: absolute;
        top: 0;
        right: 10.463vh ;
    }
    .menimg{
        width: 107.870vh ;
        height: 96.852vh ;
        position: absolute;
        bottom: 0;
        right: 4.444vh ;
    }
    .menimg::after{
        position: absolute;
        content: "";
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 0, 0, 0)(255, 255, 255);
    }
    p{
        margin: 0;
    }
    .onediv{
        font-size: 55.556vh ;
        color: rgba(255, 255, 255, 0.3);
        text-transform: uppercase;
        font-weight: 700;
        line-height: 55.556vh ;
        position: absolute;
        left: 8.889vh ;
        top: 2.315vh ;
    }
    .virtualhead{
        font-weight: 700;
        font-size: 5.556vh ;
        line-height: 5.556vh ;
        text-transform: uppercase;
        color: #000000;
        letter-spacing: 0.25vh;
        position: absolute;
        left: 24.444vh ;
        top: 29vh ;
    }
    .descriptiontext{
        position: absolute;
        left: 15.741vh ;
        top: 55.685vh ;
        width: 73.963vh ;
        font-size: 1.852vh ;
        font-weight: 400;
        line-height: 2.593vh ;
        color: #000000;
        letter-spacing: 0.12vh;
    }
    .btn{
        position: absolute;
        left: 15.741vh ;
        top: 84.167vh ;
    }
</style>